import {
  CardHeader,
  Stack,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  blue,
  cyan,
  deepPurple,
  green,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  pink,
  purple,
  red,
  teal,
} from "@mui/material/colors";
import { useAppDispatch } from "../../app/hooks";
import { DraggableCard } from "./DraggableCard";
import { useDrop } from "react-dnd";
import { Overlay, canMoveTo, moveTo } from "./dragDrop";
export const areaColors = [
  red[100],
  pink[100],
  purple[100],
  deepPurple[100],
  indigo[100],
  blue[100],
  lightBlue[100],
  cyan[100],
  teal[100],
  green[100],
  lightGreen[100],
  lime[100],
];

export function DroppableCard({ group, index = 0, navigate }) {
  const theme = createTheme({
    components: {
      // Name of the component
      MuiCardHeader: {
        styleOverrides: {
          // The props to change the default for.
          content: {
            textAlign: "center",
          }, // No more ripple, on the whole application 💣!
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: areaColors[index % areaColors.length],
          },
        },
      },
    },
  });
  var { childs, name } = group;

  const dispatch = useAppDispatch();
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: "OrderCard",
      canDrop: () => canMoveTo(group),
      drop: () => moveTo(group, dispatch),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [group, dispatch]
  );

  return (
    <div style={{ position: "relative" }} ref={drop}>
      <ThemeProvider theme={theme}>
        <Card sx={{ minWidth: 350, maxWidth: 350, position: "relative" }}>
          <CardHeader
            title={<Typography variant="h5">{name}</Typography>}
          ></CardHeader>
          <CardContent
            sx={{
              backgroundColor: "whitesmoke",
            }}
          >
            <Stack
              spacing={1}
              direction={"row"}
              
              flexWrap={"wrap"}
              sx={{
                overflow: "auto",
                maxHeight: 600,
              }}
            >
              {childs.map((user, i) => (
                <DraggableCard key={i} user={user} container={group} />
              ))}
            </Stack>
            {/* <Stack
            sx={{
              width: '100%',
              maxWidth: 360,
              bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'auto',
              maxHeight: 300,
              '& ul': { padding: 0 },
            }}
            >
              {childs.map((user, i) => (
                <DraggableCard key={i} user={user} container={group} />
              ))}
            </Stack> */}
          </CardContent>
        </Card>
      </ThemeProvider>
      {isOver && canDrop && <Overlay color="rgba(0, 0, 0, 0.6)" />}
    </div>
  );
}
